export default [
  { type: "1000", range: [0, 1100] },
  { type: "1200", range: [1101, 1300] },
  { type: "1400", range: [1301, 1500] },
  { type: "1600", range: [1501, 1700] },
  { type: "1800", range: [1701, 1900] },
  { type: "2000", range: [1901, 2100] },
  { type: "2500", range: [2101, 2900] },
  { type: "3000", range: [2900, 0] }
];



// WEBPACK FOOTER //
// ./src/stores/vehicleInformationStore/data/engineSizeTypes.js